"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _source = require("../source");
var _stageFeaturedPresenter = _interopRequireDefault(require("./stageFeaturedPresenter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function syncFeaturePresenter(presenterId) {
  return function (dispatch) {
    dispatch((0, _source.getSources)());
    dispatch((0, _stageFeaturedPresenter["default"])(presenterId));
  };
}
var _default = exports["default"] = syncFeaturePresenter;